import styles from './ToggleButton.module.scss';

export interface ToggleButtonClickEvent {
  label: string;
  value: string;
  currentValue: boolean;
}

export interface ToggleButtonProps {
  label: string;
  value: string;
  isActive: boolean;
  onToggle: (event: ToggleButtonClickEvent) => void;
}

const ToggleButton = ({ label, value, isActive, onToggle }: ToggleButtonProps) => {
  const handleToggle = () => {
    onToggle?.({ label, value, currentValue: isActive });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleToggle();
    }
  };

  return (
    <button
      className={`${styles.toggle__button__container} ${isActive ? styles.toggle__selected : ''}`}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
    >
      <span className={styles.toggle__text}>{label}</span>
    </button>
  );
};

export default ToggleButton;
